import { ProductActivityRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class ProductActivityService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ProductActivityRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default ProductActivityService;
